export interface PatientRoomInfoResponse {
  age: number;
  basicUnitCode: string;
  dateOfBirth: string;
  needsDemarcation: string;
  patientName: string;
  procedureDescription: string;
  roomDescription: string;
  supplementaryUnitCode: string;
  surgeonName: string;
}

export interface SugicalRoomCkecResponse {
  patientRoomCheckReturn: string;
}

export interface ConsistSurgicalPatientCheckResponse {
  message: string;
}

export enum DisplayMessages {
  PATIENT_CHECKED = 'text.patient-checked',
  ENCOUNTER_NOT_FOUND = 'text.encounter-not-found',
  SURGIAL_ROOM_NOT_MATCHS = 'text.surgical-room-not-matchs'
}

export enum BarcodeExpressions {
  WRISTBAND = 'tws.barcode.wristband',
  SURGICAL_ROOM = 'text.surgical-room'
}
